module.exports = __webpack_public_path__ + "static/media/icons.7171412a.zip";